import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/home/news'
    },
    {
      path: '/',
      redirect: '/home/news'
    },
    {
      path: '/home',
      redirect: '/home/news'
    },
    {
      path: '/feeorder',
      redirect: '/home/news'
    },
    {
      path: '/home/inquire',
      redirect: '/home/inquire/public'
    },
    {
      path: '/admin',
      redirect: '/admin/login'
    },
    {
      path: '/admin/account',
      redirect: '/admin/account/user'
    },
    {
      path: '/admin/report',
      redirect: '/admin/login'
    },
    {
      path: '/admin/payment',
      redirect: '/admin/login'
    },
    {
      path: '/admin/payment/application/modify',
      redirect: '/admin/login'
    },
    {
      path: '/admin/payment/application/modify/edit',
      redirect: '/admin/login'
    },
    { // 註冊驗證
      name: 'Certification',
      path: '/certification/:id/:token',
      props: true,
      component: () => import('./views/account/Certification.vue')
    },
    { // 前台主板
      name: 'Home',
      path: '/home',
      component: () => import('./views/Home.vue'),
      children: [
        { // 首頁
          name: 'Home_News',
          path: 'news',
          component: () => import('./views/before/News.vue')
        },
        { // 註冊
          name: 'Home_Registered',
          path: 'registration',
          component: () => import('./views/account/Registered.vue')
        },
        { // 選擇身分
          name: 'Home_identity',
          path: 'identity',
          component: () => import('./views/account/identity.vue')
        },
        { // 登入
          name: 'Home_Login',
          path: 'login/:identity',
          props: true,
          component: () => import('./views/account/Login.vue')
        },
        { // 帳號權限管理主版
          name: 'Account',
          path: 'account',
          component: () => import('./views/account/Account.vue'),
          children: [
            { // 個人資訊頁
              name: 'Account_User',
              path: 'user',
              meta: { requiresAuth: true },
              component: () => import('./views/account/User.vue')
            }
          ]
        },
        { // 繳款項目管理主版
          name: 'Feeorder',
          path: '/feeorder',
          component: () => import('./views/before/Feeorder/Feeorder.vue'),
          children: [
            { // 公開項目
              name: 'Feeorder_Public',
              path: 'public',
              props: true,
              meta: { requiresAuth: true },
              component: () => import('./views/before/Feeorder/Public.vue')
            },
            { // 個人項目
              name: 'Feeorder_Personal',
              path: 'personal',
              props: true,
              meta: { requiresAuth: true },
              component: () => import('./views/before/Feeorder/Personal.vue')
            }
          ]
        },
        { // 繳款
          name: 'Payment',
          path: '/payment',
          // meta: { requiresAuth: true },
          component: () => import('./views/before/Payment.vue')
        },
        { // 繳款結束畫面(未完成)
          name: 'EndPayment',
          path: '/endpayment',
          meta: { requiresAuth: true },
          component: () => import('./views/before/EndPayment.vue')
        },
        { // 信用卡繳款結束畫面(未完成)
          name: 'EndCard',
          path: '/endcard',
          // props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/before/EndCard.vue')
        },
        { // 已繳款項目
          name: 'Home_Receipt',
          path: 'receipt',
          meta: { requiresAuth: true },
          component: () => import('./views/before/Receipt.vue')
        },
        { // 繳費單頁面
          name: 'Home_Printgen',
          path: 'printgen',
          meta: { requiresAuth: true },
          component: () => import('./views/before/printgen.vue')
        }
      ]
    },
    { // 後台主板
      name: 'Admin',
      path: '/admin',
      component: () => import('./views/Admin.vue'),
      children: [
        { // 後台登入
          name: 'Admin_Login',
          path: 'login',
          component: () => import('./views/account/AdminLogin.vue')
        },
        { // 權限管理主版
          name: 'Admin_Account',
          path: 'account',
          component: () => import('./views/account/Account.vue'),
          children: [
            { // 權限審核
              name: 'Admin_UserReview',
              path: 'user',
              component: () => import('./views/account/UserReview.vue')
            },
            { // 帳號更新
              name: 'Admin_EditUser',
              path: 'edituser',
              component: () => import('./views/account/AdminUser.vue')
            },
            { // 查詢帳號
              name: 'Admin_QueryUser',
              path: 'queryuser',
              component: () => import('./views/account/Query_User.vue')
            }
          ]
        },
        { // 收費項目管理主版
          name: 'Admin_Payment',
          path: 'payment',
          component: () => import('./views/rear/Payment/Payment.vue'),
          children: [
            { // 收費項目審核
              name: 'Admin_Payment_review',
              path: 'review',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Payment/Review.vue')
            },
            { // 繳款項目建立
              name: 'Admin_Payment_setup',
              path: 'setup',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Payment/Setup.vue')
            }
          ]
        },
        { // 繳款項目及退費主版
          name: 'Admin_Refund',
          path: 'refund',
          component: () => import('./views/rear/Refund/Refund.vue'),
          children: [
            { // 現金繳納
              name: 'Admin-Receipt',
              path: 'receipt',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Refund/Receipt.vue')
            },
            { // 繳款項目查詢及退費申請
              name: 'Admin-ReceiptReport',
              path: 'receipt_report',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Refund/Receipt_Report.vue')
            }
          ]
        },
        { // 銷帳管理及報表主版
          name: 'Admin_Report',
          path: 'report',
          component: () => import('./views/rear/Report/Report.vue'),
          children: [
            { // 銷帳總表
              name: 'Admin_AllFinancialTable',
              path: 'all',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Report/AllFinancial.vue')
            },
            { // 銷帳明細表
              name: 'Admin_DetailFinancialTable',
              path: 'detail',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Report/DetailFinancial.vue')
            },
            { // 銷帳明細表
              name: 'Admin_QueryDuplicate',
              path: 'aquery',
              meta: { requiresAuth: true },
              component: () => import('./views/rear/Report/QueryDuplicate.vue')
            }
          ]
        },
        { // 退費頁面
          name: 'Admin_Refund_Application',
          path: 'refund_application/:fid/:rid',
          props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/rear/Refund_application.vue')
        },
        { // 權限申請
          name: 'Admin_Access_Request',
          path: 'access_request/:id/type/:type/:again',
          props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/account/Access_Request.vue')
        },
        { // 申請收費項目表
          name: 'Admin_Application',
          path: 'application/:type',
          props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/rear/Application.vue')
        },
        { // 變更收費項目表
          name: 'Admin_Application_Edit',
          path: '/application/:app/:fee/:type',
          props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/rear/Modifylication.vue')
        },
        { // 繳款項目詳細資料
          name: 'Admin_Payment_Receipt_Show',
          path: 'receipt_show/:id',
          props: true,
          meta: { requiresAuth: true },
          component: () => import('./views/rear/Refund/Receipt_Show.vue')
        }
      ]
    }
  ],
  /* 切換頁面回到頂端 */
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
